import countries from 'i18n-iso-countries';

countries.registerLocale(
  require('i18n-iso-countries/langs/en.json')
);

export function getCountries() {
  const countryNames = countries.getNames('en', { select: 'official' });

  return Object.entries(countryNames)
    .map(([id, name]) => ({
      id,
      name: id === 'LT' ? 'Lietuva' : name
    }))
    .sort((a, b) => a.name.localeCompare(b.name));
}



// WEBPACK FOOTER //
// ./src/js/utils/countries.js